import {AlertService}  from  '@/app/alerts/services'
import axios from '@/libs/axios'

const alertModel={
   id:"",
   name:"",
   type:"",
   notificators:"",
   allDevices:false,
   allGeofences:false,
   from:"",
   to:""
   
  
}





const initialState = () => {

  return {
   
   loading: false,
   errors: null,
   typesOptions: [ ],
   notificatorsOptions:[],
   data:  Object.assign({}, alertModel)

   
  }
}


const state = initialState()


const mutations = {


   ALERT_DATA_RESET (state) {
    Object.assign(state, ...initialState);
  },


  DATA_REQUEST (state) {
    Object.assign(state, { loading: true, errors: null });
  },

  INIT_STATE (state) {
    const model = Object.assign({}, alertModel)
    Object.assign(state, {
      loading: false,
       errors: null,
       data:{
        ...model,
       }
    }
    )
  },

  SET_TYPES_LIST(state,payload){

    Object.assign(state.typesOptions,payload)
  },

  SET_NOTIFICATROS_LIST(state,payload){

    Object.assign(state.notificatorsOptions,payload)

  },


  ALERT_DATA_SUCCESS (state, payload) {
    Object.assign(state, { loading: false, data: payload });
  },

  ALERT_DATA_ERROR (state, payload) {
    Object.assign(state, {
      loading: false,
      data: null,
      errors: payload || true
    });
  },
     
};

const  static_notificators=[
  {id:"web",name:"web"},
  {id:"mail",name:"mail"}
]

const  static_types_options=[
  {id:"deviceOnline",name:"deviceOnline"},
  {id:"deviceUnknown",name:"deviceUnknown"},
  {id:"deviceOffline",name:"deviceOffline"},
  {id:"ignitionOn",name:"ignitionOn"},
  {id:"ignitionOff",name:"ignitionOff"},
  {id:"deviceMoving",name:"deviceMoving"},
  {id:"overSpeed",name:"overSpeed"},
  {id:"deviceStopped",name:"deviceStopped"},
  {id:"geofenceEnter",name:"geofenceEnter"},
  {id:"geofenceExit",name:"geofenceExit"},
  {id:"alarm",name:"alarm"},
  {id:"maintenance",name:"maintenance"}
]

const  actions ={
  attachDevicesToAlert(ctx,  data) {
    return new Promise((resolve, reject) => {
      axios.post(`links`,  data )
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  },

  clearForm(ctx) {
    ctx.commit('INIT_STATE')
  },

 fetchLists(context, authId){

  context.commit('SET_TYPES_LIST',static_types_options)
  context.commit('SET_NOTIFICATROS_LIST',static_notificators)


  },


  async fetchAlertData(context, id) {

    context.commit('DATA_REQUEST');
    
    const result = await AlertService.getAlertById(id)

      .catch(e => {
      context.commit('ALERT_DATA_ERROR', e);
    });

    if (result) {
      context.commit('ALERT_DATA_SUCCESS', result);
    
    }
 
    return result;
  },



  async saveData(context) {

    return new Promise((resolve, reject) => {
      context.commit('DATA_REQUEST')
      const alertData = context.state.data
      AlertService.updateAlert(alertData.id, alertData).then(res => {
        context.state.loading = false
        resolve(res)
      }).catch(reason => {

        reject(reason)
        context.state.loading = false
        if (reason.status === 422) {
          context.state.errors = reason.data.errors
        }
      })
    })
  },


  async createAlert(context) {
  const alertData = context.state.data
  // const  stringnotificators=alertData.notificators.toString()

  //   alertData.notificators=stringnotificators
  
    return new Promise((resolve, reject) => {   
 
      AlertService.createAlert (alertData).then(res => {
        console.log('the alert data is ',alertData)
        context.commit('INIT_STATE')
        resolve(res)
      }).catch(reason => {
        context.state.loading = false
        if (reason.status === 422) {
          context.state.errors = reason.data.errors
        }
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
